"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[921],{

/***/ 12530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U8": function() { return /* binding */ useCurrency; }
});

// UNUSED EXPORTS: useAllTokens, useIsTokenActive, useIsUserAddedToken, useOfficialsAndUserAddedTokens, useToken, useUnsupportedTokens, useWarningTokens

// EXTERNAL MODULE: ./node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(16441);
// EXTERNAL MODULE: ./node_modules/@ethersproject/strings/lib.esm/bytes32.js
var lib_esm_bytes32 = __webpack_require__(86237);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(46472);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 2 modules
var constants = __webpack_require__(56927);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(91131);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/lists/hooks.ts + 3 modules
var hooks = __webpack_require__(8074);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var multicall_hooks = __webpack_require__(410);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(40370);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/state/user/hooks/useUserAddedTokens.ts





var selectUserTokens = function(param) {
    var tokens = param.user.tokens;
    return tokens;
};
var ref;
var userAddedTokenSelector = function(chainId) {
    return (0,es/* createSelector */.P1)(selectUserTokens, function(serializedTokensMap) {
        return Object.values((ref = serializedTokensMap === null || serializedTokensMap === void 0 ? void 0 : serializedTokensMap[chainId]) !== null && ref !== void 0 ? ref : {}).map(tokens_src/* deserializeToken */.iG);
    });
};
function useUserAddedTokens_useUserAddedTokens() {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    return (0,react_redux_es/* useSelector */.v9)((0,react.useMemo)(function() {
        return userAddedTokenSelector(chainId);
    }, [
        chainId
    ]));
}

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(53337);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(19915);
;// CONCATENATED MODULE: ./src/hooks/Tokens.ts
/* eslint-disable no-param-reassign */ 












var mapWithoutUrls = function(tokenMap, chainId) {
    return Object.keys(tokenMap[chainId] || {}).reduce(function(newMap, address) {
        newMap[address] = tokenMap[chainId][address].token;
        return newMap;
    }, {});
};
/**
 * Returns all tokens that are from active urls and user added tokens
 */ function useAllTokens() {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var tokenMap = (0,esm/* useAtomValue */.Dv)(hooks/* combinedTokenMapFromActiveUrlsAtom */.i);
    var userAddedTokens = useUserAddedTokens_useUserAddedTokens();
    return (0,react.useMemo)(function() {
        return userAddedTokens// reduce into all ALL_TOKENS filtered by the current chain
        .reduce(function(tokenMap_, token) {
            tokenMap_[token.address] = token;
            return tokenMap_;
        }, // must make a copy because reduce modifies the map, and we do not
        // want to make a copy in every iteration
        mapWithoutUrls(tokenMap, chainId));
    }, [
        userAddedTokens,
        tokenMap,
        chainId
    ]);
}
/**
 * Returns all tokens that are from officials token list and user added tokens
 */ function useOfficialsAndUserAddedTokens() {
    var chainId = useActiveWeb3React().chainId;
    var tokenMap = useAtomValue(combinedTokenMapFromOfficialsUrlsAtom);
    var userAddedTokens = useUserAddedTokens();
    return useMemo(function() {
        return userAddedTokens// reduce into all ALL_TOKENS filtered by the current chain
        .reduce(function(tokenMap_, token) {
            tokenMap_[token.address] = token;
            return tokenMap_;
        }, // must make a copy because reduce modifies the map, and we do not
        // want to make a copy in every iteration
        mapWithoutUrls(tokenMap, chainId));
    }, [
        userAddedTokens,
        tokenMap,
        chainId
    ]);
}
function useUnsupportedTokens() {
    var chainId = useActiveWeb3React().chainId;
    var unsupportedTokensMap = useUnsupportedTokenList();
    return useMemo(function() {
        return mapWithoutUrls(unsupportedTokensMap, chainId);
    }, [
        unsupportedTokensMap,
        chainId
    ]);
}
function useWarningTokens() {
    var warningTokensMap = useWarningTokenList();
    var chainId = useActiveWeb3React().chainId;
    return useMemo(function() {
        return mapWithoutUrls(warningTokensMap, chainId);
    }, [
        warningTokensMap,
        chainId
    ]);
}
function useIsTokenActive(token) {
    var activeTokens = useAllTokens();
    if (!activeTokens || !token) {
        return false;
    }
    return !!activeTokens[token.address];
}
// Check if currency is included in custom list from user storage
function useIsUserAddedToken(currency) {
    var userAddedTokens = useUserAddedTokens();
    if (!currency) {
        return false;
    }
    return !!userAddedTokens.find(function(token) {
        return currency === null || currency === void 0 ? void 0 : currency.equals(token);
    });
}
// parse a name or symbol from a token response
var BYTES32_REGEX = /^0x[a-fA-F0-9]{64}$/;
function parseStringOrBytes32(str, bytes32, defaultValue) {
    return str && str.length > 0 ? str : bytes32 && BYTES32_REGEX.test(bytes32) && (0,lib_esm.arrayify)(bytes32)[31] === 0 ? (0,lib_esm_bytes32/* parseBytes32String */.F)(bytes32) : defaultValue;
}
// undefined if invalid or does not exist
// null if loading
// otherwise returns the token
function useToken(tokenAddress) {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var tokens = useAllTokens();
    var address = (0,utils/* isAddress */.UJ)(tokenAddress);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(address || undefined, false);
    var tokenContractBytes32 = (0,useContract/* useBytes32TokenContract */.gs)(address || undefined, false);
    var token = address ? tokens[address] : undefined;
    var tokenName = (0,multicall_hooks/* useSingleCallResult */.Wk)(token ? undefined : tokenContract, "name", undefined, multicall_hooks/* NEVER_RELOAD */.DB);
    var tokenNameBytes32 = (0,multicall_hooks/* useSingleCallResult */.Wk)(token ? undefined : tokenContractBytes32, "name", undefined, multicall_hooks/* NEVER_RELOAD */.DB);
    var symbol = (0,multicall_hooks/* useSingleCallResult */.Wk)(token ? undefined : tokenContract, "symbol", undefined, multicall_hooks/* NEVER_RELOAD */.DB);
    var symbolBytes32 = (0,multicall_hooks/* useSingleCallResult */.Wk)(token ? undefined : tokenContractBytes32, "symbol", undefined, multicall_hooks/* NEVER_RELOAD */.DB);
    var decimals = (0,multicall_hooks/* useSingleCallResult */.Wk)(token ? undefined : tokenContract, "decimals", undefined, multicall_hooks/* NEVER_RELOAD */.DB);
    return (0,react.useMemo)(function() {
        if (token) return token;
        if (!chainId || !address) return undefined;
        if (decimals.loading || symbol.loading || tokenName.loading) return null;
        if (decimals.result) {
            var ref, ref1, ref2, ref3;
            return new src/* Token */.WU(chainId, address, decimals.result[0], parseStringOrBytes32((ref = symbol.result) === null || ref === void 0 ? void 0 : ref[0], (ref1 = symbolBytes32.result) === null || ref1 === void 0 ? void 0 : ref1[0], "UNKNOWN"), parseStringOrBytes32((ref2 = tokenName.result) === null || ref2 === void 0 ? void 0 : ref2[0], (ref3 = tokenNameBytes32.result) === null || ref3 === void 0 ? void 0 : ref3[0], "Unknown Token"));
        }
        return undefined;
    }, [
        address,
        chainId,
        decimals.loading,
        decimals.result,
        symbol.loading,
        symbol.result,
        symbolBytes32.result,
        token,
        tokenName.loading,
        tokenName.result,
        tokenNameBytes32.result, 
    ]);
}
function useCurrency(currencyId) {
    var ref;
    var native = (0,useNativeCurrency/* default */.Z)();
    var isNative = (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toUpperCase()) === ((ref = native.symbol) === null || ref === void 0 ? void 0 : ref.toUpperCase()) || (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toLowerCase()) === constants/* GELATO_NATIVE */.ag;
    var token = useToken(isNative ? undefined : currencyId);
    return isNative ? native : token;
}


/***/ }),

/***/ 921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fh": function() { return /* binding */ useGasPrice; },
/* harmony export */   "YF": function() { return /* binding */ useSubgraphHealthIndicatorManager; }
/* harmony export */ });
/* unused harmony exports useAudioModeManager, usePhishingBannerManager, useExchangeChartManager, useExchangeChartViewManager, useZapModeManager, useIsExpertMode, useExpertModeManager, useUserSingleHopOnly, useUserSlippageTolerance, useUserFarmStakedOnly, useUserPoolStakedOnly, useUserPoolsViewMode, useUserFarmsViewMode, useUserPredictionAcceptedRisk, useUserLimitOrderAcceptedWarning, useUserPredictionChartDisclaimerShow, useUserPredictionChainlinkChartDisclaimerShow, useUserExpertModeAcknowledgementShow, useUserUsernameVisibility, useUserTransactionTTL, useAddUserToken, useRemoveUserAddedToken, useGasPriceManager, usePairAdder, toV2LiquidityToken, useTrackedTokenPairs, useWatchlistTokens, useWatchlistPools */
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46472);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40370);
/* harmony import */ var lodash_flatMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94654);
/* harmony import */ var lodash_flatMap__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_flatMap__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56974);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97477);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49770);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78073);
/* harmony import */ var hooks_Tokens__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12530);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24837);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9372);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96470);


















function useAudioModeManager() {
    var dispatch = useAppDispatch();
    var audioPlay = useSelector(function(state) {
        return state.user.audioPlay;
    });
    var toggleSetAudioMode = useCallback(function() {
        if (audioPlay) {
            dispatch(muteAudio());
        } else {
            dispatch(unmuteAudio());
        }
    }, [
        audioPlay,
        dispatch
    ]);
    return [
        audioPlay,
        toggleSetAudioMode
    ];
}
function usePhishingBannerManager() {
    var dispatch = useAppDispatch();
    var hideTimestampPhishingWarningBanner = useSelector(function(state) {
        return state.user.hideTimestampPhishingWarningBanner;
    });
    var now = Date.now();
    var showPhishingWarningBanner = hideTimestampPhishingWarningBanner ? differenceInDays(now, hideTimestampPhishingWarningBanner) >= 1 : true;
    var hideBanner = useCallback(function() {
        dispatch(hidePhishingWarningBanner());
    }, [
        dispatch
    ]);
    return [
        showPhishingWarningBanner,
        hideBanner
    ];
}
// Get user preference for exchange price chart
// For mobile layout chart is hidden by default
function useExchangeChartManager(isMobile) {
    var dispatch = useAppDispatch();
    var isChartDisplayed = useSelector(function(state) {
        return state.user.isExchangeChartDisplayed;
    });
    var setUserChartPreference = useCallback(function(isDisplayed) {
        dispatch(setIsExchangeChartDisplayed(isDisplayed));
    }, [
        dispatch
    ]);
    return [
        isMobile ? false : isChartDisplayed,
        setUserChartPreference
    ];
}
function useExchangeChartViewManager() {
    var dispatch = useAppDispatch();
    var chartViewMode = useSelector(function(state) {
        return state.user.userChartViewMode;
    });
    var setUserChartViewPreference = useCallback(function(view) {
        dispatch(setChartViewMode(view));
    }, [
        dispatch
    ]);
    return [
        chartViewMode,
        setUserChartViewPreference
    ];
}
function useZapModeManager() {
    var dispatch = useAppDispatch();
    var zapEnabled = useSelector(function(state) {
        return !state.user.userZapDisabled;
    });
    var setZapEnable = useCallback(function(enable) {
        dispatch(setZapDisabled(!enable));
    }, [
        dispatch
    ]);
    return [
        zapEnabled,
        setZapEnable
    ];
}
function useSubgraphHealthIndicatorManager() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_9__/* .useAppDispatch */ .TL)();
    var isSubgraphHealthIndicatorDisplayed = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.isSubgraphHealthIndicatorDisplayed;
    });
    var setSubgraphHealthIndicatorDisplayedPreference = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(newIsDisplayed) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_10__/* .setSubgraphHealthIndicatorDisplayed */ .Hr)(newIsDisplayed));
    }, [
        dispatch
    ]);
    return [
        isSubgraphHealthIndicatorDisplayed,
        setSubgraphHealthIndicatorDisplayedPreference
    ];
}
function useIsExpertMode() {
    return useSelector(function(state) {
        return state.user.userExpertMode;
    });
}
function useExpertModeManager() {
    var dispatch = useAppDispatch();
    var expertMode = useIsExpertMode();
    var toggleSetExpertMode = useCallback(function() {
        dispatch(updateUserExpertMode({
            userExpertMode: !expertMode
        }));
    }, [
        expertMode,
        dispatch
    ]);
    return [
        expertMode,
        toggleSetExpertMode
    ];
}
function useUserSingleHopOnly() {
    var dispatch = useAppDispatch();
    var singleHopOnly = useSelector(function(state) {
        return state.user.userSingleHopOnly;
    });
    var setSingleHopOnly = useCallback(function(newSingleHopOnly) {
        dispatch(updateUserSingleHopOnly({
            userSingleHopOnly: newSingleHopOnly
        }));
    }, [
        dispatch
    ]);
    return [
        singleHopOnly,
        setSingleHopOnly
    ];
}
function useUserSlippageTolerance() {
    var dispatch = useAppDispatch();
    var userSlippageTolerance = useSelector(function(state) {
        return state.user.userSlippageTolerance;
    });
    var setUserSlippageTolerance = useCallback(function(slippage) {
        dispatch(updateUserSlippageTolerance({
            userSlippageTolerance: slippage
        }));
    }, [
        dispatch
    ]);
    return [
        userSlippageTolerance,
        setUserSlippageTolerance
    ];
}
function useUserFarmStakedOnly(isActive) {
    var dispatch = useAppDispatch();
    var userFarmStakedOnly = useSelector(function(state) {
        return state.user.userFarmStakedOnly;
    });
    var setUserFarmStakedOnly = useCallback(function(stakedOnly) {
        var farmStakedOnly = stakedOnly ? FarmStakedOnly.TRUE : FarmStakedOnly.FALSE;
        dispatch(updateUserFarmStakedOnly({
            userFarmStakedOnly: farmStakedOnly
        }));
    }, [
        dispatch
    ]);
    return [
        userFarmStakedOnly === FarmStakedOnly.ON_FINISHED ? !isActive : userFarmStakedOnly === FarmStakedOnly.TRUE,
        setUserFarmStakedOnly, 
    ];
}
function useUserPoolStakedOnly() {
    var dispatch = useAppDispatch();
    var userPoolStakedOnly = useSelector(function(state) {
        return state.user.userPoolStakedOnly;
    });
    var setUserPoolStakedOnly = useCallback(function(stakedOnly) {
        dispatch(updateUserPoolStakedOnly({
            userPoolStakedOnly: stakedOnly
        }));
    }, [
        dispatch
    ]);
    return [
        userPoolStakedOnly,
        setUserPoolStakedOnly
    ];
}
function useUserPoolsViewMode() {
    var dispatch = useAppDispatch();
    var userPoolsViewMode = useSelector(function(state) {
        return state.user.userPoolsViewMode;
    });
    var setUserPoolsViewMode = useCallback(function(viewMode) {
        dispatch(updateUserPoolsViewMode({
            userPoolsViewMode: viewMode
        }));
    }, [
        dispatch
    ]);
    return [
        userPoolsViewMode,
        setUserPoolsViewMode
    ];
}
function useUserFarmsViewMode() {
    var dispatch = useAppDispatch();
    var userFarmsViewMode = useSelector(function(state) {
        return state.user.userFarmsViewMode;
    });
    var setUserFarmsViewMode = useCallback(function(viewMode) {
        dispatch(updateUserFarmsViewMode({
            userFarmsViewMode: viewMode
        }));
    }, [
        dispatch
    ]);
    return [
        userFarmsViewMode,
        setUserFarmsViewMode
    ];
}
function useUserPredictionAcceptedRisk() {
    var dispatch = useAppDispatch();
    var userPredictionAcceptedRisk = useSelector(function(state) {
        return state.user.userPredictionAcceptedRisk;
    });
    var setUserPredictionAcceptedRisk = useCallback(function(acceptedRisk) {
        dispatch(updateUserPredictionAcceptedRisk({
            userAcceptedRisk: acceptedRisk
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionAcceptedRisk,
        setUserPredictionAcceptedRisk
    ];
}
function useUserLimitOrderAcceptedWarning() {
    var dispatch = useAppDispatch();
    var userLimitOrderAcceptedWarning = useSelector(function(state) {
        return state.user.userLimitOrderAcceptedWarning;
    });
    var setUserLimitOrderAcceptedWarning = useCallback(function(acceptedRisk) {
        dispatch(updateUserLimitOrderAcceptedWarning({
            userAcceptedRisk: acceptedRisk
        }));
    }, [
        dispatch
    ]);
    return [
        userLimitOrderAcceptedWarning,
        setUserLimitOrderAcceptedWarning
    ];
}
function useUserPredictionChartDisclaimerShow() {
    var dispatch = useAppDispatch();
    var userPredictionChartDisclaimerShow = useSelector(function(state) {
        return state.user.userPredictionChartDisclaimerShow;
    });
    var setPredictionUserChartDisclaimerShow = useCallback(function(showDisclaimer) {
        dispatch(updateUserPredictionChartDisclaimerShow({
            userShowDisclaimer: showDisclaimer
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionChartDisclaimerShow,
        setPredictionUserChartDisclaimerShow
    ];
}
function useUserPredictionChainlinkChartDisclaimerShow() {
    var dispatch = useAppDispatch();
    var userPredictionChainlinkChartDisclaimerShow = useSelector(function(state) {
        return state.user.userPredictionChainlinkChartDisclaimerShow;
    });
    var setPredictionUserChainlinkChartDisclaimerShow = useCallback(function(showDisclaimer) {
        dispatch(updateUserPredictionChainlinkChartDisclaimerShow({
            userShowDisclaimer: showDisclaimer
        }));
    }, [
        dispatch
    ]);
    return [
        userPredictionChainlinkChartDisclaimerShow,
        setPredictionUserChainlinkChartDisclaimerShow
    ];
}
function useUserExpertModeAcknowledgementShow() {
    var dispatch = useAppDispatch();
    var userExpertModeAcknowledgementShow = useSelector(function(state) {
        return state.user.userExpertModeAcknowledgementShow;
    });
    var setUserExpertModeAcknowledgementShow = useCallback(function(showAcknowledgement) {
        dispatch(updateUserExpertModeAcknowledgementShow({
            userExpertModeAcknowledgementShow: showAcknowledgement
        }));
    }, [
        dispatch
    ]);
    return [
        userExpertModeAcknowledgementShow,
        setUserExpertModeAcknowledgementShow
    ];
}
function useUserUsernameVisibility() {
    var dispatch = useAppDispatch();
    var userUsernameVisibility = useSelector(function(state) {
        return state.user.userUsernameVisibility;
    });
    var setUserUsernameVisibility = useCallback(function(usernameVisibility) {
        dispatch(updateUserUsernameVisibility({
            userUsernameVisibility: usernameVisibility
        }));
    }, [
        dispatch
    ]);
    return [
        userUsernameVisibility,
        setUserUsernameVisibility
    ];
}
function useUserTransactionTTL() {
    var dispatch = useAppDispatch();
    var userDeadline = useSelector(function(state) {
        return state.user.userDeadline;
    });
    var setUserDeadline = useCallback(function(deadline) {
        dispatch(updateUserDeadline({
            userDeadline: deadline
        }));
    }, [
        dispatch
    ]);
    return [
        userDeadline,
        setUserDeadline
    ];
}
function useAddUserToken() {
    var dispatch = useAppDispatch();
    return useCallback(function(token) {
        dispatch(addSerializedToken({
            serializedToken: token.serialize
        }));
    }, [
        dispatch
    ]);
}
function useRemoveUserAddedToken() {
    var dispatch = useAppDispatch();
    return useCallback(function(chainId, address) {
        dispatch(removeSerializedToken({
            chainId: chainId,
            address: address
        }));
    }, [
        dispatch
    ]);
}
function useGasPrice() {
    var ref;
    var ref1 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), chainId = ref1.chainId, chain = ref1.chain;
    var userGas = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.gasPrice;
    });
    var data = (0,wagmi__WEBPACK_IMPORTED_MODULE_12__/* .useFeeData */ .LK)({
        chainId: chainId,
        enabled: chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC && chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET,
        watch: true
    }).data;
    if (chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC) {
        return userGas;
    }
    if (chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET) {
        return _types__WEBPACK_IMPORTED_MODULE_11__/* .GAS_PRICE_GWEI.testnet */ .j4.testnet;
    }
    if (chain === null || chain === void 0 ? void 0 : chain.testnet) {
        var ref2;
        return data === null || data === void 0 ? void 0 : (ref2 = data.formatted) === null || ref2 === void 0 ? void 0 : ref2.maxPriorityFeePerGas;
    }
    return data === null || data === void 0 ? void 0 : (ref = data.formatted) === null || ref === void 0 ? void 0 : ref.gasPrice;
}
function useGasPriceManager() {
    var dispatch = useAppDispatch();
    var userGasPrice = useGasPrice();
    var setGasPrice = useCallback(function(gasPrice) {
        dispatch(updateGasPrice({
            gasPrice: gasPrice
        }));
    }, [
        dispatch
    ]);
    return [
        userGasPrice,
        setGasPrice
    ];
}
function serializePair(pair) {
    return {
        token0: pair.token0.serialize,
        token1: pair.token1.serialize
    };
}
function usePairAdder() {
    var dispatch = useAppDispatch();
    return useCallback(function(pair) {
        dispatch(addSerializedPair({
            serializedPair: serializePair(pair)
        }));
    }, [
        dispatch
    ]);
}
/**
 * Given two tokens return the liquidity token that represents its liquidity shares
 * @param tokenA one of the two tokens
 * @param tokenB the other token
 */ function toV2LiquidityToken(param) {
    var _param = _sliced_to_array(param, 2), tokenA = _param[0], tokenB = _param[1];
    return new Token(tokenA.chainId, Pair.getAddress(tokenA, tokenB), 18, "Cake-LP", "Pancake LPs");
}
/**
 * Returns all the pairs of tokens that are tracked by the user for the current chain ID.
 */ function useTrackedTokenPairs() {
    var chainId = useActiveWeb3React().chainId;
    var tokens = useOfficialsAndUserAddedTokens();
    var _chainId;
    // pinned pairs
    var pinnedPairs = useMemo(function() {
        return chainId ? (_chainId = PINNED_PAIRS[chainId]) !== null && _chainId !== void 0 ? _chainId : [] : [];
    }, [
        chainId
    ]);
    var ref = useSWRImmutable(chainId && [
        "track-farms-pairs",
        chainId
    ], /*#__PURE__*/ _async_to_generator(function() {
        var farms, fPairs;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getFarmConfig(chainId)
                    ];
                case 1:
                    farms = _state.sent();
                    fPairs = farms.filter(function(farm) {
                        return farm.pid !== 0;
                    }).map(function(farm) {
                        return [
                            deserializeToken(farm.token),
                            deserializeToken(farm.quoteToken)
                        ];
                    });
                    return [
                        2,
                        fPairs
                    ];
            }
        });
    })), tmp = ref.data, farmPairs = tmp === void 0 ? [] : tmp;
    // pairs for every token against every base
    var generatedPairs = useMemo(function() {
        return chainId ? flatMap(Object.keys(tokens), function(tokenAddress) {
            var token = tokens[tokenAddress];
            var // loop through all bases on the current chain
            _chainId;
            // for each token on the current chain,
            return ((_chainId = BASES_TO_TRACK_LIQUIDITY_FOR[chainId]) !== null && _chainId !== void 0 ? _chainId : [])// to construct pairs of the given token with each base
            .map(function(base) {
                if (base.address === token.address) {
                    return null;
                }
                return [
                    base,
                    token
                ];
            }).filter(function(p) {
                return p !== null;
            });
        }) : [];
    }, [
        tokens,
        chainId
    ]);
    // pairs saved by users
    var savedSerializedPairs = useSelector(function(param) {
        var pairs = param.user.pairs;
        return pairs;
    });
    var userPairs = useMemo(function() {
        if (!chainId || !savedSerializedPairs) return [];
        var forChain = savedSerializedPairs[chainId];
        if (!forChain) return [];
        return Object.keys(forChain).map(function(pairId) {
            return [
                deserializeToken(forChain[pairId].token0),
                deserializeToken(forChain[pairId].token1)
            ];
        });
    }, [
        savedSerializedPairs,
        chainId
    ]);
    var combinedList = useMemo(function() {
        return userPairs.concat(generatedPairs).concat(pinnedPairs).concat(farmPairs);
    }, [
        generatedPairs,
        pinnedPairs,
        userPairs,
        farmPairs
    ]);
    return useMemo(function() {
        // dedupes pairs of tokens in the combined list
        var keyed = combinedList.reduce(function(memo, param) {
            var _param = _sliced_to_array(param, 2), tokenA = _param[0], tokenB = _param[1];
            var sorted = tokenA.sortsBefore(tokenB);
            var key = sorted ? "".concat(tokenA.address, ":").concat(tokenB.address) : "".concat(tokenB.address, ":").concat(tokenA.address);
            if (memo[key]) return memo;
            memo[key] = sorted ? [
                tokenA,
                tokenB
            ] : [
                tokenB,
                tokenA
            ];
            return memo;
        }, {});
        return Object.keys(keyed).map(function(key) {
            return keyed[key];
        });
    }, [
        combinedList
    ]);
}
var useWatchlistTokens = function() {
    var dispatch = useAppDispatch();
    var ref;
    var savedTokens = (ref = useSelector(function(state) {
        return state.user.watchlistTokens;
    })) !== null && ref !== void 0 ? ref : [];
    var updatedSavedTokens = useCallback(function(address) {
        dispatch(addWatchlistToken({
            address: address
        }));
    }, [
        dispatch
    ]);
    return [
        savedTokens,
        updatedSavedTokens
    ];
};
var useWatchlistPools = function() {
    var dispatch = useAppDispatch();
    var ref;
    var savedPools = (ref = useSelector(function(state) {
        return state.user.watchlistPools;
    })) !== null && ref !== void 0 ? ref : [];
    var updateSavedPools = useCallback(function(address) {
        dispatch(addWatchlistPool({
            address: address
        }));
    }, [
        dispatch
    ]);
    return [
        savedPools,
        updateSavedPools
    ];
};


/***/ })

}]);